import { tokenKey, parseJwt, getAccessToken } from "./OAuth";
import { ApplicationError } from "../components/common/error/ApplicationError";
import { domain } from "../components/common/GeneralConfigurations";
import dotenv from "dotenv";
dotenv.config();

const apiUrl = process.env.REACT_APP_API_URL || "";
export const baseApiUrl = apiUrl.endsWith("/") ? apiUrl.slice(0, -1) : apiUrl;

export function getHttpHeaders() {
  let init = {
    headers: {
      Accept: "application/json",
      "content-type": "application/json; charset=utf-8",
    },
  };
  const token = localStorage.getItem(tokenKey);
  if (token) {
    init.headers.Authorization = "bearer " + token;
    const companyId = getAuthenticatedCompanyId();
    if (companyId) {
      init.headers["company"] = companyId;
    }
  }
  return init;
}

export function getHttpHeadersExcel(method) {
  let init = {
    method: method,
    responseType: "blob",
    headers: {
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "content-type": "application/xlsx",
    },
  };
  const token = localStorage.getItem(tokenKey);
  if (token) {
    init.headers.Authorization = "bearer " + token;
    const companyId = getAuthenticatedCompanyId();
    if (companyId) {
      init.headers["company"] = companyId;
    }
  }

  return init;
}

export function getHttpHeadersPowerPoint(method) {
  let init = {
    method: method,
    responseType: "blob",
    headers: {
      Accept:
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "content-type": "application/pptx",
    },
  };
  const token = localStorage.getItem(tokenKey);
  if (token) {
    init.headers.Authorization = "bearer " + token;
    const companyId = getAuthenticatedCompanyId();
    if (companyId) {
      init.headers["company"] = companyId;
    }
  }

  return init;
}

export function getAuthenticatedUser() {
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    return jwt;
  }
  return null;
}

export function getAuthenticatedUserId() {
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    return jwt.id;
  }
  return 0;
}

export function getAuthenticatedCompanyId() {
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    return jwt.company;
  }
  return 0;
}

export function getAuthenticatedUserIdWithToken(token) {
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    return jwt.id;
  }
  return 0;
}

export function getAuthenticatedUserName() {
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    const emailDomain = "@" + domain;
    let name = jwt.email.replace(emailDomain, "").replace(".", " ");
    const names = name.split(" ");
    let avatar = "";
    names.map(
      (n) =>
        (avatar +=
          n.substr(0, 1).toUpperCase() + n.substr(1).toLowerCase() + " ")
    );
    return avatar.trim();
  }
  return 0;
}

export function getUserPosition() {
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    if (jwt.position) {
      return parseInt(jwt.position);
    }
  }
  return undefined;
}

export function getUserEmail() {
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    if (jwt.email) {
      return jwt.email;
    }
  }
  return undefined;
}

export function getTenantId() {
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    if (jwt.company) {
      return jwt.company;
    }
  }
  return undefined;
}

export function userHasRolePermission(roles) {
  if (roles) {
    const token = localStorage.getItem(tokenKey);
    if (token && token !== "undefined") {
      let jwt = parseJwt(token);
      if (jwt.roles) {
        let final = false;
        let isRolesList = Array.isArray(jwt.roles);
        roles.split(",").forEach(function (role, index, arr) {
          if (isRolesList) {
            let found = jwt.roles.find((e) => e === role);
            if (found) {
              final = true;
            }
          } else if (jwt.roles === role) {
            final = true;
          }
        });
        return final;
      }
    }
  }
  return false;
}

export function userRoleFromToken() {
  var userRoles = [];
  const token = localStorage.getItem(tokenKey);
  if (token && token !== "undefined") {
    let jwt = parseJwt(token);
    let isRolesList = Array.isArray(jwt.roles);
    if (jwt.roles && !isRolesList) {
      userRoles = jwt.roles.split(",");
      return userRoles;
    } else {
      return jwt.roles;
    }
  }
  return userRoles;
}

export function userHasRolePermissionWithToken(roles, token) {
  if (roles) {
    if (token && token !== "undefined") {
      let jwt = parseJwt(token);
      if (jwt.roles) {
        let final = false;
        let isRolesList = Array.isArray(jwt.roles);
        roles.split(",").forEach(function (role, index, arr) {
          if (isRolesList) {
            let found = jwt.roles.find((e) => e === role);
            if (found) {
              final = true;
            }
          } else if (jwt.roles === role) {
            final = true;
          }
        });
        return final;
      }
    }
  }
  return false;
}

/** Generic method for Get requests */
export async function httpRequest(callbackMethod) {
  return callbackMethod()
    .then(async (response) => {
      return response;
    })
    .catch(async (error) => {
      if (error.response.status === 401 /* Unauthorized */) {
        // get a new acess token...
        return getAccessToken()
          .then(async (response2) => {
            // repeat the request...
            return callbackMethod()
              .then(async (response3) => {
                return response3;
              })
              .catch(async (error2) => {
                return handleError(error2);
              });
          })
          .catch(async (error3) => {
            return handleError(error3.response);
          });
      }
      return error.response;
    });
}

const handleError = (error) => {
  if (error.status === 403) {
    return "forbidden";
  } else if (error.status === 404) {
    return "not-found";
  }
  return "bad-request"; // 400
};

/** Generic method for Get file requests */
export async function httpRequestFile(callbackMethod) {
  let response = await callbackMethod();
  if (response.status === 200) {
    return response;
  } else if (response.status === 401 /* Unauthorized */) {
    await getAccessToken();
    response = await callbackMethod();
    if (response.status === 200) {
      return response;
    }
  } else if (response.status === 403) {
    return "forbidden";
  } else if (response.status === 404) {
    return "not-found";
  }
  throw new ApplicationError(`An error has occurred.`, response.status);
}
